// SideMenu.js
import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { supabase } from "../../supabase";
import { useAdminAuth } from "../../contexts/AdminAuthContext";
import Button from "./Button";
import styles from "./SideMenu.module.css";

function SideMenu() {
  const [logoUrl, setLogoUrl] = useState("");
  const { logout } = useAdminAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchLogo = async () => {
      const { data, error } = supabase
        .storage
        .from("asset")
        .getPublicUrl("common/logo_plab_eng.svg");

      if (error) {
        console.error("Error fetching logo:", error);
      } else {
        setLogoUrl(data.publicUrl)
      }
    };

    fetchLogo();
  }, []);

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const menuSections = [
    {
      title: "ADMIN",
      items: [
        { path: "/admin/ptl-preview", label: "AI 프리뷰" },
        { path: "/admin/team", label: "팀" },
        { path: "/admin/stadium24", label: "스타디움24" },  
        { path: "/admin/lineup", label: "라인업" },
      ]
    },
    {
      title: "LABORATORY",
      items: [
        { path: "/admin/stadium", label: "스타디움" },
        { path: "/pds", label: "플랩 디자인 시스템",
          external: true },
        { 
          path: "/project/plab24", 
          label: "플랩24",
          external: true
        },
        { path: "/project/match-assistant", label: "매치 어시스턴트",
          external: true },
      ]
    }
  ];

  return (
    <div className={styles.sideMenu}>
      <div className={styles.logoContainer}>
        {logoUrl && <img src={logoUrl} alt="Logo" className={styles.logo} />}
      </div>
      
      {menuSections.map((section, index) => (
        <div key={index} className={styles.menuSection}>
          <div className={styles.sectionTitle}>{section.title}</div>
          {section.items.map((item) => (
            item.external ? (
              <a
                key={item.path}
                href={item.path}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.menuItem}
              >
                <span>{item.label}</span>
                <img 
                  src="/asset/icon_external_link.svg" 
                  alt="external link" 
                  className={styles.externalIcon}
                />
              </a>
            ) : (
              <NavLink
                key={item.path}
                to={item.path}
                className={({ isActive }) =>
                  isActive ? styles.activeMenuItem : styles.menuItem
                }
              >
                {item.label}
              </NavLink>
            )
          ))}
        </div>
      ))}

      {/* 로그아웃 버튼 */}
      <div className={styles.logoutContainer}>
        <Button onClick={handleLogout} size="Small" styleType="Tertiary" width="Full">
          로그아웃
        </Button>
      </div>
    </div>
  );
}

export default SideMenu;